import * as React from 'react';
import Formsy from 'formsy-react';
import cx from 'classnames';
import {Button} from 'components/Button';
import {FormsyInput} from 'components/Input';
import style from './Feedback.css';
import ReCAPTCHA from 'react-google-recaptcha';

import {isMobile} from '_utils';

export class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.disableButton = this.disableButton.bind(this);
        this.enableButton = this.enableButton.bind(this);

        this.state = {
            canSubmit: false,
            reCaptcha: null
        };
    }

    disableButton() {
        this.setState({canSubmit: false});
    }

    enableButton() {
        this.setState({canSubmit: true});
    }

    onChange = (value) => {
        this.setState({
            reCaptcha: value
        });
    };

    submit = (model) => {
        fetch('/api/send_contact_form', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'g-recaptcha-response': this.state.reCaptcha,
                contact_form: model
            })
        });
        this.recaptcha.reset();
        this.form.reset();
    };

    render() {
        const {className} = this.props;

        return (
            <div className={cx(style.root, className)}>
                <header><h3 className={style.title}>Leave a message</h3></header>
                <Formsy
                    ref={(c) => { this.form = c; }}
                    onValidSubmit={this.submit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                >
                    <div className={style.row}>
                        <FormsyInput
                            label="Name"
                            name="name"
                            placeholder="Your name"
                            required
                            validationErrors={{
                                isDefaultRequiredValue: 'Field is required'
                            }}
                        />
                    </div>
                    <div className={style.row}>
                        <FormsyInput
                            label="E-mail"
                            name="email"
                            placeholder="yourmail@mail.com"
                            validations="isEmail"
                            validationErrors={{
                                isDefaultRequiredValue: 'Field is required',
                                isEmail: "This is not a valid email"
                            }}
                            required
                        />
                    </div>
                    <div className={style.row}>
                        <FormsyInput
                            type="textarea"
                            label="Comment or Message"
                            name="message"
                            placeholder="Write your message"
                            validationErrors={{
                                isDefaultRequiredValue: 'Field is required'
                            }}
                            required
                        />
                    </div>
                    <div className={style.row}>
                        <ReCAPTCHA
                            size={isMobile ? 'compact' : 'normal'}
                            ref={c => this.recaptcha = c}
                            sitekey="6LfM4WkUAAAAAO3itAPhNubI9A9ujYrT7tpJGlwN"
                            onChange={this.onChange}
                        />
                    </div>
                    <Button type="submit" className={style.submit}>
                        submit
                    </Button>
                </Formsy>
            </div>
        );
    }
}